import { useForm as useFormHook } from "hooks";
import { JsonableFields } from "consts/onboarding";
import type { OnboardingBankingAndFinance as OnboardingBankingAndFinanceType } from "features/onboarding/types";
import {
    FormField,
    type OnboardingBankingAndFinance,
    type OnboardingBankingAndFinanceForm
} from "./types";
import useValidationSchema from "./useValidationSchema";

export const getInitialValues = ({
    accountHolderName,
    bankName,
    iban,
    swift,
    ...restInitialValues
}: Partial<OnboardingBankingAndFinanceType>): OnboardingBankingAndFinance => ({
    [FormField.AccountHolderName]: accountHolderName ?? '',
    [FormField.BankName]: bankName ?? '',
    [FormField.Iban]: iban ?? '',
    [FormField.Swift]: swift ?? '',
    [FormField.ProofFileKey]: null,
    [FormField.Currency]: null,
    [FormField.AvgTransactionSize]: '',
    [FormField.MonthlyIncome]: '',
    [FormField.TransactionVolume]: '',
    [JsonableFields.RequestedChangeFields]: null,
    [JsonableFields.FieldsStatuses]: null,
    [JsonableFields.FieldsComments]: null,
    ...restInitialValues
});

export const useForm = (onboardingBankingAndFinance: OnboardingBankingAndFinanceForm) =>
    useFormHook({
        isInitialValid: false,
        ...onboardingBankingAndFinance,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
